import styled, { css } from 'styled-components';

export const StyledSelectWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  border: 1px solid ${({ theme, noBorder }) => noBorder ? 'transparent' : theme.colors.lightGrey};
  border-radius: 5px;
  height: 44px;
  transition: border 0.3s;
  cursor: pointer;
`;

export const StyledSelect = styled.select`
  ${({ theme, font }) => font ? font : theme.fonts.mulishLight};
  font-size: 14px;
  line-height: 1.5;
  letter-spacing: -0.025em;
  color: ${({ theme, color }) => color ? color : theme.colors.darkGrey};
  border: 0;
  outline: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: transparent;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSI1Ljk5OSIgdmlld2JveD0iMCAwIDEwIDUuOTk5Ij4NCiAgICA8Zz4NCiAgICAgICAgPHBhdGggZD0iTTQuNTUxIDUuODA3TC4xOCAxLjEzNmEuNzEuNzEgMCAwMTAtLjk0NC42LjYgMCAwMS44ODMgMEw1IDQuMzk5IDguOTM3LjE5MmEuNi42IDAgMDEuODgzIDAgLjcxLjcxIDAgMDEwIC45NDRMNS40MzQgNS44MDdhLjYuNiAwIDAxLS44ODMgMHoiIGZpbGw9IiMzMzMiIGZpbGwtcnVsZT0iZXZlbm9kZCIgLz4NCiAgICA8L2c+DQo8L3N2Zz4=");
  background-repeat: no-repeat;
  background-position-x: calc(100% - 15px);
  background-position-y: 18px;
  padding: 10px 40px 10px 15px;
  height: 100%;
  cursor: pointer;
  ::placeholder {
    color: ${({ theme }) => theme.colors.mediumGrey};
  };
`;

export const StyledSelectOption = styled.option``;

export const StyledSelectContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  margin-bottom: 20px;
  ${({ disabled }) => disabled && css`
    pointer-events: none;
    opacity: 0.5;
  `};
  ${({ readonly }) => readonly && css`
    pointer-events: none;
    opacity: 0.7;
  `};
  ${({ error }) => error && css`
    ${StyledSelectWrapper} {
      border: 1px solid ${({ theme }) => theme.colors.error};
    };
  `};
  ${({ fullWidth }) => fullWidth && css`
    width: 100%;
    ${StyledSelect} {
      width: 100%;
    };
  `};
  ${({ customStyle }) => customStyle && customStyle};
`;